<template>
    <v-app class="news-page">
        <v-container class="news-page__container">
            <h1>
                Новости и события
            </h1>
            <v-layout wrap row class="news-page__list">
                <v-flex xs12 lg6 v-for="(article, key) in showedArticles" :key="key" class="news-page__list__item">
                    <a :href="article.link">
                        <img
                            :src="article.img_path"
                            loading="eager"
                            fetchpriority="high"
                        />
                        <v-flex v-html="formatData(article.published_at)" class="news-page__published-date"></v-flex>
                        <h3 v-html="article.title"></h3>
                    </a>
                </v-flex>
            </v-layout>
            <v-flex v-if="showedArticles.length < articles.length">
                <a @click="showMore" class="news-page__show-more">Показать ещё</a>
            </v-flex>
        </v-container>
    </v-app>
</template>
<script>
import moment from "moment";
    export default {
        props: ['articles', 'category'],
        data: () => ({
            showedArticles: [],
        }),
        mounted: function() {
            this.showMore()
        },
        methods: {
            formatData(date) {
                return moment(date).format('DD.MM.YYYY')
            },
            showMore() {
                for (let i = 0; i < 4; i++){
                    if(this.articles[this.showedArticles.length]) {
                        this.showedArticles.push(this.articles[this.showedArticles.length])
                    } else {
                        return
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/NewsPage.vue